<template>
  <div class="mailing">
    <v-card>
      <v-tabs v-model="tab" centered>
        <v-tab v-for="item in items" :key="item">
          {{ item }}
        </v-tab>
      </v-tabs>
    </v-card>
    <v-tabs-items v-model="tab" class="mt-2">
      <v-tab-item>
        <v-card-text>
          <FZ44 />
        </v-card-text>
      </v-tab-item>
      <v-tab-item>
        <v-card-text>
          <FZ223 />
        </v-card-text>
      </v-tab-item>
      <v-tab-item>
        <v-card-text>
          <FZ615 />
        </v-card-text>
      </v-tab-item>
      <v-tab-item>
        <v-card-text>
          <Unsubsribe />
        </v-card-text>
      </v-tab-item>
      <v-tab-item>
        <v-card-text>
          <Statistic />
        </v-card-text>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import FZ44 from "./44.vue";
import FZ223 from "./223.vue";
import FZ615 from "./615.vue";
import Unsubsribe from "./Unsubsribe.vue";
import Statistic from "./Statistic.vue";

export default {
  name: "mail_to_winners",
  components: { FZ44, FZ223, FZ615, Unsubsribe, Statistic },
  data: () => ({
    tab: 0,
    items: ["44-ФЗ", "223-ФЗ", "615-ФЗ", "Отписавшиеся", "Статистика"],
  }),
  methods: {},
  mounted() {
    this.tab = localStorage.getItem("mailing")
      ? parseInt(localStorage.getItem("mailing"))
      : 0;
  },
  watch: {
    tab(val) {
      localStorage.setItem("mailing", val);
      switch (val) {
        case 0: {
          this.setTitle("Рассылка по 44-ФЗ");
          break;
        }
        case 1: {
          this.setTitle("Рассылка по 223-ФЗ");
          break;
        }
        case 2: {
          this.setTitle("Рассылка по 615-ФЗ");
          break;
        }
        case 3: {
          this.setTitle("Отписавшиеся от Рассылки");
          break;
        }
        case 4: {
          this.setTitle("Статистика по Рассылке");
          break;
        }
      }
    },
  },
};
</script>
<style lang="sass" scoped>
.mailing
  display: grid
  grid-gap: 20px
</style>
